import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useAppSettings } from "@/hooks/useAppSettings";

export default function AppFooter() {
  const { t, locale } = useLanguage();
  const { appVersion, isBeta, instagramUrl, instagramVisible } = useAppSettings();
  const faqHref = locale === "en" ? "/en/faq/" : "/faq/";

  return (
    <footer className="w-full border-t border-border bg-card/30 py-4">
      <div className="mx-auto flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-0 text-xs text-muted-foreground">
        <span>© 2026 drumLog.Pro</span>
        <span className="hidden sm:inline mx-2">|</span>
        <div className="flex items-center gap-2">
          <Link to="/imprint" className="hover:text-primary transition-colors">{t.imprint?.title ?? "Impressum"}</Link>
          <span>|</span>
          <Link to="/privacy" className="hover:text-primary transition-colors">{t.privacy?.title ?? "Datenschutzerklärung"}</Link>
          <span>|</span>
          <Link to={faqHref} className="hover:text-primary transition-colors">FAQ</Link>
          <span>|</span>
          <span className="tabular-nums">
            v{appVersion}{isBeta ? " BETA" : ""}
          </span>
          {instagramVisible && instagramUrl && (
            <>
              <span>|</span>
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-3.5 w-3.5" />
              </a>
            </>
          )}
        </div>
      </div>
    </footer>
  );
}
